export default [
  'https://8team-rolling.netlify.app/profile/man01.jpg',
  'https://8team-rolling.netlify.app/profile/girl01.jpg',
  'https://8team-rolling.netlify.app/profile/man02.jpg',
  'https://8team-rolling.netlify.app/profile/man03.png',
  'https://8team-rolling.netlify.app/profile/girl02.png',
  'https://8team-rolling.netlify.app/profile/man04.png',
  'https://8team-rolling.netlify.app/profile/man05.png',
  'https://8team-rolling.netlify.app/profile/man06.png',
  'https://8team-rolling.netlify.app/profile/girl03.png',
  'https://8team-rolling.netlify.app/profile/girl04.png',
];
